module.exports = __webpack_public_path__ + "static/img/bg.f2c0a05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/bg.png
// module id = N4LK
// module chunks = 0